/**
 * Loads a string from storage.
 *
 * @param key The key to fetch.
 */
export function loadString(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

/**
 * Saves a string to storage.
 *
 * @param key The key to fetch.
 * @param value The value to store.
 */
export function saveString(key: string, value: string): boolean {
  try {
    localStorage.setItem(key, value)
    return true
  } catch {
    return false
  }
}

/**
 * Loads something from storage and runs it through JSON.parse.
 *
 * @param key The key to fetch.
 */
export function load(key: string): string | null {
  try {
    const almostThere: any = localStorage.getItem(key)
    return JSON.parse(almostThere)
  } catch {
    return null
  }
}

/**
 * Saves an object to storage.
 *
 * @param key The key to fetch.
 * @param value The value to store.
 */
export function save(key: string, value: any): boolean {
  try {
    localStorage.setItem(key, JSON.stringify(value))
    return true
  } catch {
    return false
  }
}

/**
 * Removes something from storage.
 *
 * @param key The key to kill.
 */
export function remove(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch (e) {
    process.env.NODE_ENV === "development" && console.warn(e)
  }
}

/**
 * Burn it all to the ground.
 */
export function clear(): void {
  try {
    localStorage.clear()
  } catch (e) {
    process.env.NODE_ENV === "development" && console.warn(e)
  }
}

export const LAYOUT_SIDEBAR_OPEN = "LAYOUT_SIDEBAR_OPEN"
